/* eslint-disable import/no-default-export */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import {
    contactDealerModalTypes,
    PDP_PASSWORD_RESET_ORIGIN,
    SHOW_CONTACT_DEALER_PARAM,
} from '../src/ContactDealerModal/helpers/constants';

export default function contactDealerLauncher({
    currency,
    environment,
    itemId,
    launchOrigin,
    modalType,
    sellerId,
    showAppInstallPrompt,
    userId,
    onSuccessfulShippingQuoteRequest,
}) {
    const modalContainer = document.createElement('div');
    const unmount = () => ReactDOM.unmountComponentAtNode(modalContainer);
    import(
        /* webpackChunkName: "contactDealerModal" */
        '../src/ContactDealerModal/contactDealerAsyncImports'
    ).then(mod => {
        const { components, helpers } = mod;

        const rendererProps = {
            environment,
            itemId,
            launchOrigin,
            modalType,
            pageCurrency: currency,
            sellerId,
            showAppInstallPrompt,
            userId,
            onSuccessfulShippingQuoteRequest,
            unmount,
        };

        const { ContactDealerModal, IntlProvider } = components;
        const { serverVars } = helpers;

        ReactDOM.render(
            <IntlProvider
                locale={serverVars.get('locale') || 'en'}
                messages={serverVars.get('messages')}
            >
                <ContactDealerModal {...rendererProps} />
            </IntlProvider>,
            modalContainer
        );
    });
}

export const useContactDealerAutoModal = ({
    launchOrigin = PDP_PASSWORD_RESET_ORIGIN,
    itemId,
    userId,
    environment,
    currency,
}) => {
    useEffect(() => {
        if (!userId || !itemId || typeof window === 'undefined') {
            return;
        }
        const searchParams = new URLSearchParams(window.location.search);
        const showContactDealerParam = searchParams.get(SHOW_CONTACT_DEALER_PARAM);

        if (showContactDealerParam) {
            searchParams.delete(SHOW_CONTACT_DEALER_PARAM);
            const cleanSearchParams = searchParams.toString();
            const searchParamString = cleanSearchParams ? `?${cleanSearchParams}` : '';
            window.history.replaceState('', '', window.location.pathname + `${searchParamString}`); // remove the param so we only trigger modal once
            contactDealerLauncher({
                environment,
                itemId,
                modalType: contactDealerModalTypes.CONTACT_DEALER,
                launchOrigin,
                currency,
                userId,
            });
        }
    }, [currency, userId, itemId, environment, launchOrigin]);
};
